import React, { PropsWithChildren, useState } from 'react'

// components
import Sidebar from 'components/Sidebar'
import PageTemplate from 'pages/shared/PageTemplate'
import UnsubscribedUserHeader from 'components/UnsubscribedUserHeader'

const UnsubscribedUserPageLayout: React.FC<PropsWithChildren> = ({children}) => {
  const [isMenuOpen, setMenuOpen] = useState(false)

  const reverseMenuOpen = (shouldClose?: any) => {
    if (shouldClose === 'shouldClose') {
      setMenuOpen(false)
    } else {
      setMenuOpen(!isMenuOpen)
    }
  }
  
  return (
    <>
      <div className="d-flex">
        <Sidebar isOpen={isMenuOpen} onClick={reverseMenuOpen} disabled/>
        <div className="page-content">
          <UnsubscribedUserHeader/>
          <PageTemplate>
            {children}
          </PageTemplate>
        </div>
      </div>
    </>
  )
}

export default UnsubscribedUserPageLayout
